<template>
  <zt-dialog
    :append-to-body="true"
    :modal-append-to-body="false"
    width="440px"
    :visible.sync="visible"
    title="设定排序"
  >
    <el-form label-position="left" label-width="90px">
      <el-form-item label="频道">
        <el-radio-group v-model="form.channel" :min="1">
          <el-radio :label="1">人工精选</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="排序序号" :error="order_id_error">
        <zt-input type="number" v-model="form.order_id" placeholder="请输入排序序号" width="200px"></zt-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <zt-button type="primary" @click="sbtStick">确定</zt-button>
    </div>
  </zt-dialog>
</template>

<script>
import { admin_items_reorder_publish } from '@/api/pkEdit';

const defForm = {
  id: '',
  channel: 1,
  order_id: '',
};

export default {
  data: () => ({
    visible: false,

    form: {
      ...defForm,
    },

    order_id_error: '',
  }),
  methods: {
    open(info) {
      this.visible = true;
      this.form = { ...defForm };
      Object.assign(this.form, {
        id: info.id,
      });
      this.order_id_error = '';
    },
    // 提交 - 置顶
    sbtStick() {
      let form = { ...this.form };
      if (!form.order_id) {
        this.order_id_error = '排序序号不能为空';
        return;
      }
      this.order_id_error = '';
      admin_items_reorder_publish({
        ...form,
      }).then(({ data }) => {
        if (this.$requestResultMessage(data)) {
          this.$message.success('修改成功，1分钟后生效。');
          this.$emit('submit');
          this.visible = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>